

export default {
    props: {
        orgName: {
            type: String,
            require: true,
        },
    },
    emits: ['close'],
    methods: {
        close() {
            this.$emit('close');
        }
    },
    async mounted() {
    },
    data() {
        return {
        }
    }
};
